/**
 * Markazlashgan Ant Design tema — toza/oq, ko'k urg'u (minimalist).
 * Barcha komponentlar shu yagona manbadan uslub oladi.
 */
export const appTheme = {
    token: {
        colorPrimary: '#2563EB',
        colorInfo: '#2563EB',
        colorSuccess: '#10B981',
        colorWarning: '#F59E0B',
        colorError: '#EF4444',

        colorText: '#1E293B',
        colorTextSecondary: '#64748B',
        colorTextTertiary: '#94A3B8',
        colorBorder: '#E2E8F0',
        colorBorderSecondary: '#EEF2F6',

        colorBgLayout: '#F8FAFC',
        colorBgContainer: '#FFFFFF',
        colorBgElevated: '#FFFFFF',

        borderRadius: 8,
        borderRadiusLG: 12,
        borderRadiusSM: 6,

        controlHeight: 38,
        fontSize: 14,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",

        // Yumshoq, minimal soyalar
        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
        boxShadowSecondary: '0 4px 12px rgba(16, 24, 40, 0.08)',

        wireframe: false,
    },
    components: {
        Layout: {
            headerBg: '#FFFFFF',
            headerHeight: 64,
            headerPadding: '0 24px',
            siderBg: '#FFFFFF',
            bodyBg: '#F8FAFC',
        },
        Menu: {
            itemBg: 'transparent',
            itemSelectedBg: '#EFF6FF',
            itemSelectedColor: '#2563EB',
            itemHoverBg: '#F1F5F9',
            itemColor: '#475569',
            itemHeight: 42,
            itemBorderRadius: 8,
            itemMarginInline: 8,
            iconSize: 16,
            fontSize: 14,
        },
        Table: {
            headerBg: '#F8FAFC',
            headerColor: '#475569',
            headerSplitColor: 'transparent',
            borderColor: '#EEF2F6',
            rowHoverBg: '#F8FAFC',
            cellPaddingBlock: 12,
            cellPaddingInline: 16,
            headerBorderRadius: 10,
            fontWeightStrong: 600,
        },
        Card: {
            borderRadiusLG: 12,
            paddingLG: 20,
            colorBorderSecondary: '#EEF2F6',
        },
        Modal: {
            borderRadiusLG: 14,
            headerBg: '#FFFFFF',
            titleColor: '#1E293B',
            contentBg: '#FFFFFF',
            paddingcontentHorizontal: 24,
        },
        Drawer: {
            colorBgElevated: '#FFFFFF',
        },
        Button: {
            controlHeight: 38,
            fontWeight: 500,
            primaryShadow: 'none',
            defaultShadow: 'none',
            borderRadius: 8,
        },
        Input: { controlHeight: 38, borderRadius: 8 },
        InputNumber: { controlHeight: 38, borderRadius: 8 },
        Select: { controlHeight: 38, borderRadius: 8 },
        DatePicker: { controlHeight: 38, borderRadius: 8 },
        Tag: { borderRadiusSM: 6 },
        Segmented: { borderRadius: 8 },
    },
};
